/**
 * Leaflet Map Component - OpenStreetMap Integration
 * 
 * Uses Leaflet with OpenStreetMap tiles (free and open source)
 */

'use client';

import type { Property } from '@/lib/api/clients/properties';
import dynamic from 'next/dynamic';

// Dynamically import Leaflet to avoid SSR issues
const LeafletMapClient = dynamic(() => import('./LeafletMapClient'), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <div className="text-4xl mb-2">🗺️</div>
        <p className="text-gray-600">Loading map...</p>
      </div>
    </div>
  ),
});

interface LeafletMapProps {
  properties: Property[];
  selectedPropertyId: string | null;
  hoveredPropertyId?: string | null;
  onMarkerClick: (property: Property) => void;
  className?: string;
}

export function LeafletMap(props: LeafletMapProps) {
  return <LeafletMapClient {...props} />;
}
